module.exports = __webpack_public_path__ + "media/images/shieldgps-logo1-5084821df02b6cff891c3faea445524c.svg";